var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48.04 40.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff3b83;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,34.94a1.76,1.76,0,0,0,.09-.2A3.49,3.49,0,0,1,3.59,32H44.35A3.43,3.43,0,0,1,48,35a7.26,7.26,0,0,1,0,2.28A3.38,3.38,0,0,1,44.75,40H3.8A3.57,3.57,0,0,1,.42,38.18,7.8,7.8,0,0,1,0,37.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29,14h5.47a1.49,1.49,0,0,1,1.36,2.21,2.07,2.07,0,0,1-.34.44L25.2,27.46a1.49,1.49,0,0,1-2.37,0q-5.14-5.39-10.3-10.78a1.5,1.5,0,0,1-.39-1.75A1.52,1.52,0,0,1,13.7,14H19v-.56c0-3.55,0-7.1,0-10.65A2.64,2.64,0,0,1,21.84,0c1.45.07,2.9.07,4.36,0A2.65,2.65,0,0,1,29,2.86c-.06,3.51,0,7,0,10.55Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.954b4f0f064028bbe995f9d056cd0fe7.svg";
export { ForwardRef as ReactComponent };